import axios from 'axios'
import newTask from '../../dto/NewTask.json'
import _ from 'lodash'
import moment from 'moment'
import taskActions from '@/utils/task-actions'

const initState = {
  listView: {
    list: [],
    total: 0,
    page: 1,
    limit: 30,
    filters: {
      searchStr: '',
      executed: false,
      myTasks: false,
      tasksByExecutorRole: false,
      executor: null,
      period: [null, null],
      customer: null,
    },
    sort: { sortBy: 'date', sortDesc: false },
  },
  openTask: _.cloneDeep(newTask),
  parentView: '',
}

export const state = Object.assign({}, _.cloneDeep(initState))

export const mutations = {
  setListViewProperty(state: any, payload: any) {
    Object.keys(payload).forEach((key) => {
      state.listView[key] = payload[key]
    })
  },

  setFilters(state: any, filter: any) {
    Object.keys(filter).forEach((key) => {
      state.listView.filters[key] = filter[key]
    })
  },

  setSort(state: any, sort: any) {
    Object.keys(sort).forEach((key) => {
      state.listView.sort[key] = sort[key]
    })
  },
  setOpenTask(state: any, task: any) {
    if (!task) {
      state.openTask = _.cloneDeep(newTask)
    } else {
      state.openTask = task
    }
  },
  setTaskProperty(state: any, { property, value }: any) {
    state.openTask[property] = value
  },
  setTaskProperties(state: any, properties: any) {
    for (const property of Object.keys(properties)) {
      state.openTask[property] = properties[property]
    }
  },
  setTaskFiles(state: any, files: any) {
    state.openTask.files = files
  },
  deleteTaskFile(state: any, index: any) {
    state.openTask.files.splice(index, 1)
  },
  setParentView(state: any, view: any) {
    state.parentView = view
  },
  resetState(state: any) {
    Object.assign(state, _.cloneDeep(initState))
  },
}

export const actions = {
  async findAll({ commit }: any, payload: any) {
    let list: any = []
    let page: any = 1
    let total: any = 0

    return axios
      .get(`/task`, payload)
      .then(async (response) => {
        if (response.status === 200) {
          const result = response.data

          if (result.rows) {
            list = result.rows
          } else {
            list = result
          }

          list.forEach(async (el: any) => {
            el.createdAt = moment(el.createdAt).format('DD.MM.YYYY HH:mm:ss')
            el.date = moment(el.date).format('DD.MM.YYYY HH:mm:ss')

            if (el.executionPeriod) {
              el.executionPeriod = moment(el.executionPeriod).format('DD.MM.YYYY HH:mm')
            }

            el.ownerData = ''

            if (el.ownerType && el.ownerId) {
              if (el.ownerType === 'reclamation') {
                const response = await axios.get(`/getreclamation/${el.ownerId}`, {})
                if (response) {
                  const reclamationeData = response.data.responseData
                  el.baseDocument = 'Recl. nr ' + reclamationeData.number + ' ref: ' + reclamationeData.salesReference
                }
              }
            }
          })

          if (result.count) {
            total = result.count
          } else {
            total = list.length
          }

          if (total > 0) {
            const pages = Math.ceil(total / state.listView.limit)

            if (pages < state.listView.page) {
              page = pages
            } else {
              page = state.listView.page
            }
          }
        }

        if (!payload.noCommit) {
          commit('setListViewProperty', { list, page, total })
        }

        return response
      })
      .catch((error) => {
        if (!payload.noCommit) {
          commit('setListViewProperty', { list, page, total })
        }
        console.error(error)
        throw error
      })
  },

  async getOrderTasks(context: any, payload: any) {
    return axios.get(`/task`, payload).then((response) => {
      const tasks = response.data

      tasks.forEach((el: any) => {
        el.createdAt = moment(el.createdAt).format('DD.MM.YYYY HH:mm:ss')
        el.date = moment(el.date).format('DD.MM.YYYY HH:mm:ss')
        el.executionPeriod = moment(el.executionPeriod).format('DD.MM.YYYY HH:mm')
      })

      return tasks
    })
  },

  async findByPk({ commit }: any, payload: any) {
    return axios
      .get(`/task/${payload.params.id}`, payload.query)
      .then((response) => {
        const task = response.data

        if (task.emailDate) {
          task.emailDate = moment(task.emailDate).format('DD.MM.YYYY HH:mm:ss')
        }

        if (task.executionPeriod) {
          task.executionPeriod = moment(task.executionPeriod).format('YYYY-MM-DDThh:mm')
        }

        for (const taskOrder of task.orders) {
          taskOrder.order.createdAt = moment(taskOrder.order.createdAt).format('DD.MM.YYYY HH:mm:ss')
        }

        if (!payload.noCommit) {
          commit('setOpenTask', task)
        }

        return task
      })
      .catch((error) => {
        console.error(error)
        const openTask = _.cloneDeep(newTask)
        commit('setOpenTask', openTask)
        return openTask
      })
  },

  async createTask({ getters }: any, payload: any) {
    const writeTask = _.cloneDeep(getters.openTask)
    return axios.post(`/task`, writeTask).then((response) => {
      return response
    })
  },

  async updateTask({ getters }: any, payload: any) {
    const updateTask = _.cloneDeep(getters.openTask)
    delete updateTask.presentation
    return axios.put(`/task/${updateTask.id}`, updateTask).then((response) => {
      return response
    })
  },

  async update(context: any, payload: any) {
    return axios.put(`/task/${payload.id}`, payload.updateData).then((response) => {
      return response
    })
  },

  async deleteTask(context: any, payload: any) {
    return axios.delete(`/task/${payload.id}`, payload).then((response) => {
      return response
    })
  },

  async checkBeforeExecutionTaskCondition({ dispatch, state }: any, payload: any) {
    let executeTask = true
    if (state.openTask.bpDefinition && state.openTask.stage) {
      const bpDefinition = await dispatch(
        'bpDefinitions/findByPk',
        {
          params: {
            id: state.openTask.bpDefinition,
          },
        },
        { root: true }
      )

      if (bpDefinition) {
        const currentStage = bpDefinition.stages.find((stage: any) => stage.id === state.openTask.stage)
        if (currentStage.beforeExecution) {
          const reclamationResponse = await axios.get(`/getreclamation/${state.openTask.ownerId}`, {})
          if (reclamationResponse) {
            const currentReclamationData = reclamationResponse.data.responseData
            const conditionArgs = {
              task: state.openTask,
              reclamation: currentReclamationData,
            }
            executeTask = taskActions.executeConditionCode(currentStage.beforeExecution, conditionArgs)
          }
        }
      }
    }
    return executeTask
  },

  async executeOnStageExecution({ dispatch, state }: any, params: any) {
    const bpDefinitions = await dispatch(
      'bpDefinitions/findByPk',
      {
        params: {
          id: params.bpDefinition,
        },
      },
      { root: true }
    )

    if (bpDefinitions) {
      const currentStage = bpDefinitions.stages.find((stage: any) => stage.id === params.currentStageId)

      const reclamationResponse = await axios.get(`/getreclamation/${params.ownerId}`, {})

      if (currentStage) {
        if (currentStage.onExecution) {
          if (reclamationResponse) {
            const currentReclamationData = reclamationResponse.data.responseData
            const conditionArgs = {
              task: state.openTask,
              reclamation: currentReclamationData,
            }
            taskActions.executeAsyncConditionCode(currentStage.onExecution, conditionArgs)
          }
        }
      }

      if (params.nextStageId) {
        const nextStage = bpDefinitions.stages.find((stage: any) => stage.id === params.nextStageId)
        if (nextStage.beforeExecution) {
          if (reclamationResponse) {
            const currentReclamationData = reclamationResponse.data.responseData
            const nextStageconditionArgs = {
              task: state.openTask,
              reclamation: currentReclamationData,
            }
            await taskActions.executeAsyncConditionCode(nextStage.beforeExecution, nextStageconditionArgs)
          }
        }
      }
    }
  },

  async checkBeforeExecutionTaskCondition2(context: any, payload: any) {
    const currentStage = payload.currentStage
    let executeTask = true
    if (currentStage) {
      const conditionArgs = {}
      executeTask = taskActions.executeConditionCode(currentStage.beforeExecution, conditionArgs)
    }

    return executeTask
  },

  async createTaskBasingOnManualRedirection({ dispatch }: any, params: any) {
    const bpDefinitions = await dispatch(
      'bpDefinitions/findByPk',
      {
        params: {
          id: params.bpDefinition,
        },
      },
      { root: true }
    )

    const executionTerm = new Date()
    executionTerm.setHours(0, 0, 0, 0)
    executionTerm.setDate(executionTerm.getDate() + 1)

    const newTaskParams = _.cloneDeep(newTask)
    newTaskParams.executionPeriod = executionTerm
    newTaskParams.ownerType = params.ownerType
    newTaskParams.ownerId = params.ownerId
    newTaskParams.name = params.nextStage
    newTaskParams.lang = params.lang
    newTaskParams.stage = params.nextStageId
    newTaskParams.subjectString = params.nextStage
    newTaskParams.customerId = params.customerId
    newTaskParams.bp = bpDefinitions.data
    newTaskParams.bpDefinition = params.bpDefinition
    newTaskParams.executorId = params.nextExecutorId
    newTaskParams.executorRoleId = params.nextExecutorRoleId
    newTaskParams.started = params.started

    await axios.post(`/task`, newTaskParams)
  },

  async createTaskBasingOnBusinessProcessDefinitions({ dispatch }: any, params: any) {
    const bpDefinitions = await dispatch(
      'bpDefinitions/findByPk',
      {
        params: {
          id: params.bpDefinition,
        },
      },
      { root: true }
    )

    if (bpDefinitions) {
      const currentStage = bpDefinitions.stages.find((stage: any) => stage.id === params.currentStageId)

      if (currentStage) {
        if (currentStage.next) {
          const nextStage = bpDefinitions.stages.find((stage: any) => stage.id === currentStage.next)

          if (nextStage) {
            if (nextStage.isCondition === false) {
              const executionTerm = new Date()
              executionTerm.setHours(0, 0, 0, 0)
              if (nextStage.executionTerm) {
                executionTerm.setDate(executionTerm.getDate() + Number(nextStage.executionTerm))
              }
              const newTaskParams = _.cloneDeep(newTask)
              newTaskParams.executionPeriod = executionTerm
              newTaskParams.ownerType = params.ownerType
              newTaskParams.ownerId = params.ownerId
              newTaskParams.name = nextStage.text
              newTaskParams.stage = nextStage.id
              newTaskParams.subjectString = nextStage.text
              newTaskParams.customerId = params.customerId
              newTaskParams.bpDefinition = bpDefinitions.id
              newTaskParams.executorId = nextStage.executorId > 0 ? nextStage.executorId : null
              newTaskParams.executorRoleId = nextStage.executorRoleId > 0 ? nextStage.executorRoleId : null
              await axios.post(`/task`, newTaskParams)
            } else {
              if (nextStage.conditionCode) {
                const reclamationResponse = await axios.get(`/getreclamation/${params.ownerId}`, {})
                if (reclamationResponse) {
                  const currentReclamationData = reclamationResponse.data.responseData
                  const conditionArgs = {
                    task: params,
                    reclamation: currentReclamationData,
                  }
                  const conditionRes = taskActions.executeConditionCode(nextStage.conditionCode, conditionArgs)
                  if (nextStage.next && conditionRes === true) {
                    params.currentStageId = nextStage.id
                    dispatch('createTaskBasingOnBusinessProcessDefinitions', params)
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  async checkForSimpleCondition({ dispatch }: any, params: any) {
    let normalStageFound = false

    const bpDefinitions = await dispatch(
      'bpDefinitions/findByPk',
      {
        params: {
          id: params.bpDefinition,
        },
      },
      { root: true }
    )
    if (bpDefinitions) {
      const currentStage = bpDefinitions.stages.find((stage: any) => stage.id === params.currentStageId)
      if (currentStage) {
        if (currentStage.next) {
          const nextStage = bpDefinitions.stages.find((stage: any) => stage.id === currentStage.next)
          if (nextStage) {
            if (nextStage.isCondition === false) {
              normalStageFound = true
            } else {
              if (nextStage.manualStageDefinition === true && normalStageFound === false) {
                const reclamationResponse = await axios.get(`/getreclamation/${params.ownerId}`, {})
                if (reclamationResponse) {
                  const currentReclamationData = reclamationResponse.data.responseData
                  const conditionArgs = {
                    task: params,
                    reclamation: currentReclamationData,
                  }
                  const conditionRes = taskActions.executeConditionCode(nextStage.conditionCode, conditionArgs)
                  if (nextStage.next && conditionRes === true) {
                    params.currentStageId = nextStage.id
                    dispatch('createTaskBasingOnBusinessProcessDefinitions', params)
                  }
                }
              }
            }
          }
        }
      }
    }
  },

  async cancelTaskExecution({ commit }: any, payload: any) {
    const updateData = {
      executionResult: payload.executionResult,
    }

    return axios.put(`/execute_task/${payload.id}`, updateData).then((response) => {
      commit('setOpenTask', _.cloneDeep(newTask))
      return response
    })
  },

  async executeTask({ commit }: any, payload: any) {
    const updateData = {
      executionResult: payload.executionResult,
    }

    return axios.put(`/execute_task/${payload.id}`, updateData).then((response) => {
      commit('setOpenTask', _.cloneDeep(newTask))
      return response
    })
  },

  async acceptToExecutionTask(context: any, payload: any) {
    return axios
      .put(`/accept_exec_task/${payload.id}`)
      .then((response) => {
        return response
      })
      .catch((error) => {
        throw error
      })
  },

  async uploadFiles({ getters }: any, params: any) {
    const formData = new FormData()

    params.files.map((file: any) => formData.append('files', file))

    formData.append('data', JSON.stringify({ id: getters.openTask.id }))

    return axios
      .post(`/task/file`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
  },

  async getFiles({ commit }: any, params: any) {
    return axios
      .post(`/task/object_file`, { objectId: params.taskId })
      .then((response) => {
        commit('setTaskFiles', response.data)
        return response
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
  },

  async deleteFile({ commit }: any, params: any) {
    return axios
      .delete(`/task/file/${params.id}`, {})
      .then((response) => {
        if (response.status === 200) {
          commit('deleteTaskFile', params.index)
        }
        return response
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
  },

  async openFile(context: any, params: any) {
    return axios
      .get(`/task/file/${params.id}`, { responseType: 'blob' })
      .then((response) => {
        if (response.status === 200) {
          const blob = new Blob([response.data], { type: params.type })
          const fileLink = document.createElement('a')
          fileLink.href = window.URL.createObjectURL(blob)

          if (params.open === true && (params.type === 'application/pdf' || params.type === 'image/jpeg' || params.type === 'image/png')) {
            fileLink.target = '_blank'
            fileLink.rel = 'noopener noreferrer'
          } else {
            fileLink.setAttribute('download', params.name)
          }

          document.body.appendChild(fileLink)
          fileLink.click()
        }
        return response
      })
      .catch((error) => {
        console.error(error)
        return undefined
      })
  },

  resetState({ commit }: any) {
    commit('resetState')
  },
}

export const getters = {
  listView(state: any) {
    return state.listView
  },
  openTask(state: any) {
    return state.openTask
  },
  parentView(state: any) {
    return state.parentView
  },
}
